import React, { useContext } from "react";
import { VegaButtonLink, VegaBox } from "@heartlandone/vega-react";
import {VegaDialog, VegaNotify} from "@heartlandone/vega";
import { _fetch } from "Chore/Request";
import { PATH } from "Chore/Apis";
import { HubContext } from "Redux/Context/context";
import { toggleGlobalModalAction, reloadActivitiesAction } from "Redux/Actions/actions";

const { CANCEL_REGISTER } = PATH;

function CancelRegistrationAction({ activity }) {
  const { id } = activity;
  const { globalModalDispatch, reloadActivitiesDispatch } = useContext(HubContext);
  const confirm = () => {
    VegaDialog.open({
      title: "Cancel Registration",
      content: "Are you sure you want to cancel your registration for the activity?",
      okButton: { label: "Yes", size: "small" },
      cancelButton: { label: "No", size: "small" },
      handleOk: async () => {
        onCancelRegisterClick();
        return true;
      },
    });
  };
  const onCancelRegisterClick = () => {
    _toggleModal(true);
    _fetch({
      api: CANCEL_REGISTER(id),
      method: "DELETE",
    })
      .then((res) => {
        if (res.code === 2200) {
          reloadActivitiesDispatch(
            reloadActivitiesAction({reloadBy: 'cancel-registration'})
          );
        }
        if(res.code === 4400 && res.message){
          VegaNotify.open({
            type: 'error',
            message: res.message
          });
        }
      })
      .finally(() => {
        _toggleModal(false);
      });
  };

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({ isShow }));
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label="Cancel Registration"
        icon="fa-solid fa-xmark"
        onVegaClick={confirm}
      />
    </VegaBox>
  );
}

export default CancelRegistrationAction;
